export enum SliceName {
  userProfile = "userProfile",
  audience = "audience",
  searchQuery = "searchQuery",
  metaData = "metaData",
  alert = "alert"
}
